import city from './city.json';

const cascader = Object.keys(city).map((province) => ({
  value: province,
  label: province,
  children: (city[province] || []).map((c) => ({ value: c, label: c })),
}));

export default cascader;
